import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#7df3e1',
  },
  stopZero: {
    stopColor: '#33B7BE',
  },
  stopShift: {
    stopColor: '#318CCA',
  },
  logoFirst: {
    fill: 'url(#logo-first)',
    strokeWidth: 0,
  },
  logoSecond: {
    fill: 'url(#logo-second)',
    strokeWidth: 0,
  },
  logoThird: {
    fill: 'url(#logo-third)',
    strokeWidth: 0,
  },
  base: {
    fill: 'none',
    strokeWidth: 0,
  }
});

const PlattLogoIcon = () => {
  const classes = useStyles();

  return (
<svg
  className={classes.svg}
  xmlns="http://www.w3.org/2000/svg"
  version="1.1"
  viewBox="0 0 192 192">
  <defs>
    <linearGradient id="logo-first" x1="108.5" y1="11.2" x2="43.1" y2="126.9" gradientUnits="userSpaceOnUse">
      <stop  offset="0" className={classes.stopZero} />
      <stop  offset="0.7" className={classes.stopShift} />
    </linearGradient>
    <linearGradient id="logo-second" x1="186.5" y1="55.3" x2="121.2" y2="171">
      <stop  offset="0" className={classes.stopZero} />
      <stop  offset="0.7" className={classes.stopShift} />
    </linearGradient>
    <linearGradient id="logo-third" x1="128.2" y1="22.3" x2="62.8" y2="138">
      <stop  offset="0" className={classes.stopZero} />
      <stop  offset="0.7" className={classes.stopShift} />
    </linearGradient>
  </defs>
  <g>
    <path className={classes.logoFirst}
      d="M78.8,63.1c1.4.8,3,1.2,4.6,1.2,3.2,0,6.3-1.6,8-4.6l26.5-45.9c2.5-4.4,1-10-3.4-12.6-4.4-2.5-10-1-12.6,3.4l-26.5,45.9c-2.5,4.4-1,10,3.4,12.6Z"/>
    <path className={classes.logoSecond}
      d="M168.5,173.6H60.5c-5.1,0-9.2,4.1-9.2,9.2s4.1,9.2,9.2,9.2h108c5.1,0,9.2-4.1,9.2-9.2s-4.1-9.2-9.2-9.2Z"/>
    <path className={classes.logoThird}
      d="M183.7,88.6l-30.6-53.1c-1.6-2.8-4.7-4.6-8-4.6h-21.1c.2,0,.3,0,.5,0-1.7,0-3.3.3-4.9,1.2-4.4,2.5-5.9,8.2-3.4,12.6l11.9,20.6-25.3,43.9h-50.7l-25.3-43.9,25.3-43.9h23.8c5.1,0,9.2-4.1,9.2-9.2s-4.1-9.2-9.2-9.2h-29.1c-3.3,0-6.3,1.8-8,4.6L8.3,60.7c-1.6,2.8-1.6,6.3,0,9.2l30.6,53.1c1.6,2.8,4.7,4.6,8,4.6h30.8s-15.2,0-15.2,0l13.4,23.3c1.6,2.8,4.7,4.6,8,4.6h61.3c3.3,0,6.3-1.8,8-4.6l30.6-53.1c1.6-2.8,1.6-6.3,0-9.2ZM125.4,31c0,0-.2,0-.3,0,0,0,.2,0,.3,0Z"/>
  </g>
  <rect className={classes.base} width="192" height="192"/>    
</svg>
  );
};

export default PlattLogoIcon;
